module.exports = __webpack_public_path__ + "img/moqieji.38125800.jpg";